import { EntityStatus } from '../../../core/interfaces/entity-status';
import { Enum } from '../../../core/interfaces/object-enum';

export class DestinationStatusEnum extends Enum {
  static OK = new EntityStatus('Active', 'OK', 'success');
  static FAILED_PERMANENTLY = new EntityStatus('Failed', 'FAILED_PERMANENTLY', 'error');
}

